<template>
  <div v-if="disclosureText">
    <button class="btn btn-link m-0 p-0 my-auto ms-3" @click="openModal">
      AI Disclosure
    </button>
    <div
      class="modal fade"
      id="AIDisclosureModalStaticBackdrop"
      ref="aiDisclosureModal"
      data-bs-backdrop="static"
      tabindex="-1"
      aria-label="AIDisclosureModalLabel"
      aria-labelledby="AIDisclosureModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header modal-title fw-bold w-100">
            AI Disclosure
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="closeModal"
            ></button>
          </div>
          <div class="modal-body text-start p-4">
            <p>{{ disclosureText }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Modal } from "bootstrap";
import config from "@/data/config.json";

export default {
  name: "AIDisclosureModal",
  data() {
    return {
      modal: null,
      disclosureText: config.aiDisclosure?.text || ""
    };
  },
  methods: {
    openModal() {
      this.modal.show();
    },
    closeModal() {
      this.modal.hide();
    }
  },
  mounted() {
    if (this.disclosureText) {
      this.modal = new Modal(this.$refs.aiDisclosureModal);
    }
  }
};
</script>
